function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea7a1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea7a1"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $0cc9a1e0faef5436$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"6gHc5":"index.2415261d.js","9lG97":"worker.066485bf.js","aTlLu":"worker.18fe396d.js","iNLpW":"zappar-cv.315eebda.wasm","2i9Pw":"face_mesh_face_model.9f3b859a.zbin","hZ0qN":"face_mesh_full_head_simplified_model.caf9de0a.zbin","iBylp":"face_tracking_model.624095d1.zbin","5K2PS":"macula.768fcc00.png","fnlsC":"cataracts.7b0a9104.png","idKzf":"bluenoise.bdbe3726.png","iH9Wz":"camouflage-1.d85fb5f3.png","9JylQ":"camouflage-2.86017a97.png","k5jqV":"camouflage-3.8b41ea77.png","g4uRk":"camouflage-4.adf313fc.png","dZso2":"camouflage-5.3f24d933.png","kzAtO":"tunnel-1.a917dd34.png","eXWaU":"tunnel-2.d74b03aa.png","5GbAk":"tunnel-3.12655810.png","fjjT3":"tunnel-4.791a15c4.png","dqYJk":"tunnel-5.9fb7f8ec.png","jKBTe":"glaucoma-1.1baf327f.png","4CNuz":"glaucoma-2.ccd4b3ce.png","hLaCZ":"glaucoma-3.06451552.png","dCgW2":"glaucoma-4.6ed5cde2.png","4Toe9":"glaucoma-5.f7fea49e.png","3ZZKc":"index.a95ebe3e.css"}'));


//# sourceMappingURL=index.7d9c4858.js.map
